import { appendScript } from '@tencent/pa-cms-utils';
export async function getServerInfo() {
  if (!(window as any).TRSSJServerSelect) {
    await appendScript(
      'https://trl.tarisglobal.com/game_area/en/trssj_server_select_utf8.js'
    );
  }
  return (window as any).TRSSJServerSelect;
}
export async function getSeverList() {
  const serverInfo = await getServerInfo();
  const areaIncludeList = ['11', '12', '13', '14', '15'];
  // 目前游戏内只有这几个服务器
  // ASIA: 30001~30003
  // NA: 35001
  // LATAM: 40001~40002
  // EU: 45001~45003
  // EE: 50001
  const serverIncludeList = [
    '30001',
    '30002',
    '30003',
    '35001',
    '40001',
    '40002',
    '45001',
    '45002',
    '45003',
    '50001',
  ];

  return areaIncludeList.map((serverId) => {
    const area = serverInfo.STD_CHANNEL_DATA.find(
      (item: any) => item.v === serverId
    );
    const server = serverInfo.STD_DATA.filter(
      (item: any) => item.c === serverId && serverIncludeList.includes(item.v)
    );
    return {
      ...area,
      server,
    };
  });
}
